import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class VersionService {

  constructor(private http: HttpClient) {}

  getVersion(): Observable<string> {
    let epoch: number = Math.round(Date.now() / 1000)
    return this.http.get(`/assets/version.json?epoch=${epoch}`).map(
      (data: any) => {
        return data.version;
      },
      (errors) => console.log("Failed to get version.")
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/version.service.ts